"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _offerActions = require("../actions/offer-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  offerPackagesByApplicationUuid: {// 'a6d3c3d4-369a-11e8-b467-0ed5f89f718b': {
    //   applicationUuid: '',
    //   declineReasons: [''],
    //   nonAutopayAdditionalRate: undefined, // number
    //   decision: 'INITIAL|SELECT|FINAL',
    //   min: undefined, // number
    //   minDraw: undefined, // number
    //   max: undefined, // number
    //   maxDraw: undefined, // number
    //   minOther: undefined, // number
    //   minOtherDraw: undefined, // number
    //   maxOther: undefined, // number
    //   maxOtherDraw: undefined, // number
    //   hasOriginationFees: false,
    //   hasMultipleOriginationFees: false,
    //   offersByType: [
    //     {
    //       type: 'FIXED',
    //       min: undefined, // number
    //       minDraw: undefined, // number
    //       max: undefined, // number
    //       maxDraw: undefined, // number
    //       minOther: undefined, // number
    //       minOtherDraw: undefined, // number
    //       maxOther: undefined, // number
    //       maxOtherDraw: undefined, // number
    //       offers: [
    //         {
    //           id: '', // compound tier + term
    //           rate: 0,
    //           otherRate: 0, // most likely rate + 2
    //           primeRate: 0, // FIXED = 0, FLOATING > 0
    //           term: 0,
    //           min: 0,
    //           minDraw: 0,
    //           max: 0,
    //           maxDraw: 0,
    //           type: 'FIXED|FLOATING'
    //         }
    //         ...
    //       ]
    //     },
    //     ...
    //   ],
    //   incomeVerificationResultUuid: '',
    //   subDecision: '',
    //   plaidItemUuids: [''],
    //   statedTotalIncome: 0,
    //   verifiedTotalIncome: 0,
    //   incomeRequestRecords: [
    //     {
    //       uuid: '',
    //       plaidItemUuids: [''],
    //       vendor: '',
    //       methods: ['']
    //     },
    //     ...
    //   ],
    //   incomeResultRecordUuids: ['']
    //   rateDiscountResponse: [{ type: '', amount: 0 }]
    // }
  },
  loading: false
}; // TODO: move to util

exports.initialState = initialState;

var drawAmount = function drawAmount(amount, fee) {
  return amount / (1.0 + fee);
};

function parseOffersMinMax() {
  var offers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var reduce = function reduce(accValue, value, mathTask) {
    return typeof accValue === 'undefined' ? value : mathTask(accValue, value);
  };

  var reduceWithNulls = function reduceWithNulls(accValue, value, mathTask) {
    if (typeof accValue !== 'number') {
      return value;
    }

    return typeof value === 'number' ? mathTask(accValue, value) : accValue;
  };

  return offers.reduce(function (acc, o) {
    return {
      min: reduce(acc.min, o.min, Math.min),
      minDraw: reduce(acc.minDraw, drawAmount(o.min, o.originationFee), Math.min),
      max: reduce(acc.max, o.max, Math.max),
      maxDraw: reduce(acc.maxDraw, drawAmount(o.max, o.originationFee), Math.max),
      minOther: reduceWithNulls(acc.minOther, o.minOther, Math.min),
      minOtherDraw: reduceWithNulls(acc.minOtherDraw, drawAmount(o.minOther, o.originationFee), Math.min),
      maxOther: reduceWithNulls(acc.maxOther, o.maxOther, Math.max),
      maxOtherDraw: reduceWithNulls(acc.maxOtherDraw, drawAmount(o.maxOther, o.originationFee), Math.max)
    };
  }, {
    min: undefined,
    minDraw: undefined,
    max: undefined,
    maxDraw: undefined,
    minOther: undefined,
    minOtherDraw: undefined,
    maxOther: undefined,
    maxOtherDraw: undefined
  });
}

var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, "".concat(_offerActions.GET_OFFER_PACKAGE, "_").concat(_httpActions.REQUEST), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_offerActions.GET_OFFER_PACKAGE, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var _action$payload = action.payload,
      applicationUuid = _action$payload.applicationUuid,
      offers = _action$payload.offers;
  var offerPackage = state.offerPackagesByApplicationUuid[applicationUuid] || {};
  var offerTypeMap = {};
  (offers || []).forEach(function (o) {
    if (!offerTypeMap[o.type]) offerTypeMap[o.type] = [];
    offerTypeMap[o.type].push(o);
  });
  var offersByType = Object.entries(offerTypeMap).map(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    var minMax = parseOffersMinMax(v);
    var oldOffersByType = (offerPackage.offersByType || []).find(function (ot) {
      return ot.type === k;
    }) || {};
    return _objectSpread(_objectSpread({}, oldOffersByType), {}, {
      type: k,
      min: minMax.min,
      minDraw: minMax.minDraw,
      max: minMax.max,
      maxDraw: minMax.maxDraw,
      minOther: minMax.minOther,
      minOtherDraw: minMax.minOtherDraw,
      maxOther: minMax.maxOther,
      maxOtherDraw: minMax.maxOtherDraw,
      // TODO: determine if we need to merge list here or not
      offers: v.map(function (o) {
        return Object.assign({}, o, {
          id: "".concat(o.term, "-").concat(o.type, "-").concat(o.min, "-").concat(o.max, "-").concat(o.originationFee),
          minDraw: drawAmount(o.min, o.originationFee),
          minOtherDraw: drawAmount(o.minOther, o.originationFee),
          maxDraw: drawAmount(o.max, o.originationFee),
          maxOtherDraw: drawAmount(o.maxOther, o.originationFee)
        });
      }).sort(function (o1, o2) {
        if (o1.term === o2.term) return o1.max - o2.max;
        return o1.term - o2.term;
      })
    });
  });
  var minMax = parseOffersMinMax(offers);
  var maxOriginationFee = offers.reduce(function (acc, cur) {
    return Math.max(acc, cur.originationFee);
  }, 0);
  return _objectSpread(_objectSpread({}, state), {}, {
    offerPackagesByApplicationUuid: _objectSpread(_objectSpread({}, state.offerPackagesByApplicationUuid), {}, (0, _defineProperty2.default)({}, applicationUuid, _objectSpread(_objectSpread({}, offerPackage), {}, {
      applicationUuid: applicationUuid,
      decision: action.payload.decision,
      nonAutopayAdditionalRate: action.payload.nonAutopayAdditionalRate,
      declineReasons: offerPackage.declineReasons,
      min: minMax.min,
      minDraw: minMax.minDraw,
      max: minMax.max,
      maxDraw: minMax.maxDraw,
      minOther: minMax.minOther,
      minOtherDraw: minMax.minOtherDraw,
      maxOther: minMax.maxOther,
      maxOtherDraw: minMax.maxOtherDraw,
      maxDtiUnlimited: action.payload.maxDtiUnlimited,
      maxDtiUnlimitedDraw: drawAmount(action.payload.maxDtiUnlimited, maxOriginationFee),
      hasOriginationFees: maxOriginationFee > 0,
      hasMultipleOriginationFees: action.payload.hasMultipleOriginationFees,
      offersByType: offersByType,
      incomeVerificationResultUuid: action.payload.incomeVerificationResultUuid,
      subDecision: action.payload.subDecision,
      plaidItemUuids: (0, _toConsumableArray2.default)(action.payload.plaidItemUuids),
      statedTotalIncome: action.payload.statedTotalIncome,
      verifiedTotalIncome: action.payload.verifiedTotalIncome,
      incomeRequestRecords: action.payload.incomeRequestRecords.map(function (ir) {
        return _objectSpread(_objectSpread({}, ir), {}, {
          // assume really 1:1 on a request basis
          verificationMethod: ir.methods.find(function (m) {
            return m.indexOf('PLAID_') > -1 || m.indexOf('POINTSERV_') > -1;
          })
        });
      }),
      incomeResultRecordUuids: (0, _toConsumableArray2.default)(action.payload.incomeResultRecordUuids),
      rateDiscountResponse: action.payload.rateDiscountResponse.map(function (discount) {
        // This is a temp fix until all old apps are out of the system
        if (discount.type === 'CREDIT_UNION') discount.type = 'QUORUM';
        return discount;
      })
    }))),
    loading: false
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_offerActions.GET_OFFER_PACKAGE, "_").concat(_httpActions.FAILURE), function _(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_offerActions.GET_MERLOC_OFFER_PACKAGE, "_").concat(_httpActions.REQUEST), function _() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_offerActions.GET_MERLOC_OFFER_PACKAGE, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var _action$payload2 = action.payload,
      applicationUuid = _action$payload2.applicationUuid,
      offers = _action$payload2.offers;
  var value = state.offerPackagesByApplicationUuid[applicationUuid] || {};
  var minMax = parseOffersMinMax(offers);
  return _objectSpread(_objectSpread({}, state), {}, {
    offerPackagesByApplicationUuid: _objectSpread(_objectSpread({}, state.offerPackagesByApplicationUuid), {}, (0, _defineProperty2.default)({}, applicationUuid, _objectSpread(_objectSpread(_objectSpread({}, value), action.payload), {}, {
      min: minMax.min,
      minDraw: minMax.minDraw,
      max: minMax.max,
      maxDraw: minMax.maxDraw,
      offersByType: [{
        type: 'FIXED',
        offers: action.payload.offers.map(function (offer) {
          return _objectSpread(_objectSpread({}, offer), {}, {
            index: offer.index.toString() || ''
          });
        })
      }],
      incomeRequestRecords: action.payload.incomeRequestRecords.map(function (ir) {
        return _objectSpread(_objectSpread({}, ir), {}, {
          // assume really 1:1 on a request basis
          verificationMethod: ir.methods.find(function (m) {
            return m.indexOf('PLAID_') > -1 || m.indexOf('POINTSERV_') > -1;
          })
        });
      })
    }))),
    loading: false
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_offerActions.GET_MERLOC_OFFER_PACKAGE, "_").concat(_httpActions.FAILURE), function _(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;